import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Optional,
  Output
  // ViewChild,
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  NG_ASYNC_VALIDATORS,
  NG_VALIDATORS,
  AsyncValidatorFn,
  // NgModel,
  Validator,
  ValidatorFn,
  FormControl,
  FormGroup
} from '@angular/forms';

import {Observable} from 'rxjs';

// import {
//   initializeAccessor,
//   validate,
// } from './.';



@Component({
  selector: 'ld-checkbox',
  templateUrl: './checkbox.template.html',
  styleUrls: [ './checkbox.style.scss' ],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CheckboxComponent, // removed forwardRef as the validator and component are in the same scope
    multi: true
  }]
})
// @ControlValueAccessor<boolean>()
export class CheckboxComponent implements OnInit {
  static uniqueIdCount = 0;
  uniqueId = `checkbox-${ ++CheckboxComponent.uniqueIdCount }`;

  @Input()
  id: string = null;

  @Input()
  checkboxControl: FormControl;

  @Input() fontColor: 'default' | 'legal' | 'primary' = 'default';
  @Input() checked: boolean;
  @Input() name: string;
  @Input() qa: string;
  @Input() shouldCheckIsDirty = false;
  @Input() validationForm: FormGroup;

  private _blurEmitter: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();
  private _focusEmitter: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();
  private _focused = false;

  @Output('focus')
  get onFocus(): Observable<FocusEvent> { return this._focusEmitter.asObservable(); }

  @Output('blur')
  get onBlur(): Observable<FocusEvent> { return this._blurEmitter.asObservable(); }

  // @ViewChild(NgModel) private model: NgModel;

  constructor(
    @Optional() @Inject(NG_VALIDATORS)
      private validators: Array<Validator | ValidatorFn>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS)
      private asyncValidators: Array<Validator | AsyncValidatorFn>
  ) {
    // initializeAccessor(this);
  }

  ngOnInit() {
    if (!this.checkboxControl) {
      console.error('CheckboxComponent should be initialized with the checkboxControl input');
    }
  }

  public handleBlur(event: FocusEvent): void {
    this._focused = false;
    this._blurEmitter.emit(event);
  }

  public handleFocus(event: FocusEvent): void {
    this._focused = true;
    this._focusEmitter.emit(event);
  }

  public hasErrors() {
    return this.validationForm && this.validationForm.controls[this.name].errors &&
      (this.validationForm.controls[this.name].touched || !this.shouldCheckIsDirty) && !this._focused;
  }

  public isChecked(): boolean {
    return (
      this.checked || this.checked === false
      ? !!this.checked
      : !!this.checkboxControl.value
    );
  }

  // to internally check if the component is valid
  // return observable
  // private get invalid(): Observable<boolean> {
  //   return validate
  //     (this.validators, this.asyncValidators)
  //     (this.model.control)
  //       // .map(v => Object.keys(v || {}).length > 0);
  // }
}
